import { encryptedKeyByAesKeyValidator, encryptedKeyByRsaKeyValidator, } from '#validation';
import { CommonMemberCreateSchema } from './common-member-create.schema';
export const OwnerMemberCreateSchema = CommonMemberCreateSchema.extend({
    eAdminPrivateKeyByMemberKey: encryptedKeyByRsaKeyValidator,
    ePrivateKeyByUserKey: encryptedKeyByAesKeyValidator,
});
